// extracted by mini-css-extract-plugin
export var currencyInput = "_kf-1";
export var currencySymbol = "_kf-0";